/**
 * The configuration file for the git-ignore-config.ts file upgrading to Angular 15.
 */

export const adds = {
    '/bundle': '.angular'
}
